import { Plan } from '@smarty-nx/data'

import { PLAN_CATEGORY_LABELS, PLAN_CATEGORIES } from '../constants'

/** Returns plan category from V2 plan attributes */
export const getPlanCategory = (plan: Plan, isPreloadedSim?: boolean) => {
  if (plan?.planHasDataDiscount) return PLAN_CATEGORIES.DATA_DISCOUNT_SIM
  if (plan?.planIsDataOnly) return PLAN_CATEGORIES.DATA_ONLY_SIM
  return isPreloadedSim
    ? PLAN_CATEGORIES.PRELOADED_SIM
    : PLAN_CATEGORIES.VOICE_SIM
}

/** Returns plan category from V1 plan attributes */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getV1PlanCategory = (plan: any, isPreloadedSim?: boolean) => {
  if (plan?.data_discount) return PLAN_CATEGORIES.DATA_DISCOUNT_SIM
  if (plan?.plan_is_data_only) return PLAN_CATEGORIES.DATA_ONLY_SIM
  return isPreloadedSim
    ? PLAN_CATEGORIES.PRELOADED_SIM
    : PLAN_CATEGORIES.VOICE_SIM
}

export const getCategoryName = (plan: Plan) => plan?.categoryName?.toUpperCase()

// Contentful to DMPG ones
const PLAN_CATEGORY_MAP: Record<string, string> = {
  CLASSIC: 'voice-sim',
  DATA_ONLY: 'data-only-sim',
  DATA_DISCOUNT: 'data-discount-sim',
  SOCIAL_TARIFF: 'social-tariff',
  RETAIL: 'retail',
}

export const getV3PlansCategoryName = (plan: Plan) =>
  PLAN_CATEGORY_MAP[(plan?.categoryName || 'classic').toUpperCase()]

export const getPlanCategoryLabel = (planCategory: string) => {
  return PLAN_CATEGORY_LABELS[planCategory]
    ? PLAN_CATEGORY_LABELS[planCategory]
    : ''
}
